<template>
    <div class="lightbox" v-show="toggleLightbox" @click="handleClick">
        <div class="lightbox__content" v-if="images || single">
            <div v-if="!single && images.length > 1" class="arrow-left" @click="prevImage"></div>

            <img v-if="images !== 'undefined' && images"
                 @load="loadClose"
                 :src="images[imageOffset].permalink" alt="">

            <img v-if="single" :src="singleSrc"
                 alt=""
                 @load="loadClose">

            <div v-if="!single && images.length > 1" class="arrow-right" @click="nextImage"></div>

            <div class="close-modal" @click="handleClick">
                <img :style="{display: showClose}"
                     class="close-modal-img"
                     src="@/assets/icons/close-white.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Lightbox",
        props: ['toggle', 'images', 'offset', 'single', 'singleSrc'],
        data() {
            return {
                toggleLightbox: false,
                close: false,
                imageOffset: 0,
                showClose: 'none',
            }
        },
        methods: {
            loadClose() {
                this.showClose = 'block';
            },
            handleClick(e) {
                this.showClose = 'none';

                const target = e.target;
                const current = e.currentTarget;

                if (target.classList.value.indexOf('close-modal') !== -1 || current.classList.value.indexOf('close-modal-img') !== -1) {
                    this.$emit('closeLightbox', false);
                    return;
                }

                this.toggleLightbox = e.target !== e.currentTarget;
                this.$emit('closeLightbox', this.toggleLightbox);
            },
            nextImage() {
                if (this.imageOffset === this.images.length - 1) {
                    return
                }
                this.imageOffset++;
            },
            prevImage() {
                if (this.imageOffset === 0) {
                    return
                }
                this.imageOffset--;
            },
        },
        watch: {
            toggleLightbox() {
                this.imageOffset = this.offset;

                if (this.toggleLightbox) {
                    document.body.style.overflow = 'hidden';
                } else {
                    document.body.style.overflow = 'auto';
                }
            },
            toggle() {
                this.toggleLightbox = this.toggle || false;
            },
        },
        mounted() {
            this.imageOffset = this.offset;
        }
    }
</script>

<style lang="scss" scoped>
    .lightbox {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .8);
        width: 100%;
        height: 100vh;
        z-index: 100;
        display: flex;
        justify-content: center;
        align-items: center;

        &__content {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                border-radius: 4px;
                max-width: 600px;
            }
        }
    }

    .close-modal {
        z-index: 200;
        padding: 10px;
        position: absolute;
        top: -45px;
        right: -50px;
        cursor: pointer;
    }

    .close-modal-img {
        width: 22px;
        height: 22px;
    }

    .arrow-left, .arrow-right {
        margin: 0 30px;
        padding: 5px;
        cursor: pointer;
        background-size: cover;
        width: 40px;
        height: 40px;
    }

    .arrow-left {
        background: url('../../assets/icons/prod-prev.svg') center center no-repeat;
    }

    .arrow-right {
        background: url('../../assets/icons/prod-next.svg') center center no-repeat;
    }

    @media only screen and (max-width: 1024px) {
        .lightbox__content img {
            width: calc(100% - 15px);
        }

        .close-modal {
            top: -50px;
            right: 0px;
        }

        .close-modal-img {
            display: block;
            width: 18px !important;
            height: 18px !important;
        }
    }

    @media only screen and (max-width: 767px) {
        .lightbox__content {
            width: calc(100% - 30px);
        }

        .arrow-left, .arrow-right {
            width: 40px;
            height: 40px;
            margin: 0;
            padding: 0;
            cursor: pointer;
        }

        .arrow-left {
            background: url('../../assets/icons/amb-prev.svg') center center no-repeat;
            position: absolute;
            left: 15px;
        }

        .arrow-right {
            background: url('../../assets/icons/amb-next.svg') center center no-repeat;
            position: absolute;
            right: 15px;
        }
    }
</style>